import { render } from "./DeleteAct.vue?vue&type=template&id=1d4a195e"
import script from "./DeleteAct.vue?vue&type=script&lang=js"
export * from "./DeleteAct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__